import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import AuctionHeader from "../Header/AuctionHeader";
import Countdown from "../../../commons/CountDownTimer/Countdown";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import { ReactComponent as ExpandMoreIcon } from "../../../assets/images/expandMoreIcon.svg";
import {
  formatDateTimeView,
  formatDateType,
} from "../../../commons/FormatDate";
import OngoingConnections from "../../Bilateral/LedgerPageDashboardActive/OngoingConnections.jsx";
import {
  getequisitionsBidders,
  getequisitionsList,
} from "../../../Services/ReverseAuction/GetApi";
import CircularProgress from "./CircularProgress";

import Styles from "./BiddingScreen.module.css";
import { getTenderState } from "../../../commons/ReverseAuctionStatus";
import PlaceBid from "../../Modals/ReverseAuction/PlaceBid/PlaceBid";
import EditIcon from "@mui/icons-material/Edit";
import { Close } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DoneIcon from "@mui/icons-material/Done";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../commons/Toast/ErrorMessage";
import {
  approveQuantityRequest,
  handleRaFinalizeT_C,
  updateQuantityRequest,
  updateWinnerBidStatus,
} from "../../../Services/ReverseAuction/AlterApi";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../commons/ConfirmationModal/ConfirmationModal.jsx";
import Loader from "../../../commons/Loader/Loader.jsx";
import { Switch, styled } from "@mui/material";
import AvailableListing from "../../ConsumerGenerator/ListingContainer/AvailableListing/AvailableListing.jsx";

// ----------------- Helper Components -----------------
const TenderDetails = ({ status, tenderData, type }) => {
  console.debug(status);
  return (
    <div className={`display_flex_row ${Styles.tender_upper}`}>
      {/* Left section */}
      <div className="display_flex_row_gap_8_only" style={{ gap: "16px" }}>
        <DetailItem label="E:Tender Number" value={tenderData?.tenderNumber} />
        <DetailItem label="E.RA Number" value={tenderData?.auctionNumber} />
        {type === "CB" ? (
          <DetailItem
            label="Bidding Duration"
            value={`${formatDateTimeView(
              tenderData?.bidStartDateTime
            )} - ${formatDateTimeView(tenderData?.bidCloseDateTime)}`}
          />
        ) : type === "AUCTION" ? (
          <DetailItem
            label="Reverse Auction Duration"
            value={`${formatDateTimeView(
              tenderData?.auctionStartDateTime
            )} - ${formatDateTimeView(tenderData?.auctionCloseDateTime)}`}
          />
        ) : (
          <DetailItem
            label="Bidding Duration"
            value={`${formatDateTimeView(
              tenderData?.tenderStartDateTime
            )} - ${formatDateTimeView(tenderData?.tenderCloseDateTime)}`}
          />
        )}
      </div>

      {/* Right section */}
      <div>
        {tenderData && (
          <Countdown status={status} tenderData={tenderData} type="bid" />
        )}
      </div>
    </div>
  );
};

const DetailItem = ({ label, value }) => (
  <>
    {value && (
      <div
        className={`display_flex_column_gap_8 ${Styles.tenderHadingDetails}`}
      >
        <div>{label}</div>
        <div>{value}</div>
      </div>
    )}
  </>
);

const TenderActions = ({ tenderData, selectedBidIds, status }) => {
  const [tenderModal, setTenderModal] = useState(false);
  const location = useLocation();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  )?.toLowerCase();

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [confirmHeader, setConfirmHeader] = useState("");
  const [confirmNote, setConfirmNote] = useState("");

  const [selBidsList, setSelBidsList] = useState([]);

  console.debug(location, "location");
  const navigate = useNavigate();
  const handleNav = (val) => {
    navigate(`${val}`);
  };

  const handleFinalizeT_C = async () => {
    let payload = {
      selectedBidIds: selBidsList,
      tenderId: tenderData?.id,
      bidStage: status?.includes("ra_ongoing") ? "AUCTION" : "CB",
    };
    console.debug(payload);
    let res = await handleRaFinalizeT_C(payload);
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      navigate(`/tender_active?id=${tenderData?.id}`);
    }
  };

  const handleSettlement = async () => {
    let res = await getequisitionsList(tenderData?.id, "AUCTION");
    if (res?.data?.code === 200) {
      const pendingBids = res?.data?.data.flatMap(
        (req) =>
          req.bids?.filter(
            (bid) =>
              bid.winnerBidStatus === "PENDING" ||
              bid.winnerBidStatus === "ABSCOND"
          ) || []
      );
      if (pendingBids?.length > 0) {
        setConfirmNote(
          `There are ${pendingBids?.length} bid(s) requests currently in a pending/absconded state. Once finalized, the bids will be removed.`
        );
      }
      let bids = res?.data?.data
        .flatMap(
          (req) =>
            req.bids?.filter((bid) => bid.winnerBidStatus === "ACCEPTED") || []
        )
        .map((bid) => bid.id);
      setSelBidsList(bids);
      setTenderModal(true);
      setConfirmText(`Do you want to Finalize Terms?`);
      setConfirmHeader("Finalize Terms");
      setConfirmModal(true);
    }
  };

  return (
    <>
      {tenderModal && (
        <ConfirmationModal
          open={tenderModal}
          handleClose={() => setTenderModal(false)}
          handleSubmit={handleFinalizeT_C}
          data={confirmText}
          header={confirmHeader}
          note={confirmNote}
        />
      )}
      <div className={`display_flex_row ${Styles.tender_button_section}`}>
        <div></div>
        <div className={`display_flex_row_gap_8 ${Styles.buttonMainSection}`}>
          {(tenderData?.tenderStatus === "BUCKET_FILLED_RA" ||
            tenderData?.tenderStatus === "BUCKET_FILLED") &&
            location?.pathname === "/live_auction" &&
            role === "consumer" && (
              <div className="activeButton_type_2" onClick={handleSettlement}>
                Finalize T&C
              </div>
            )}
        </div>
      </div>
    </>
  );
};

const TableHeader = ({ role }) => (
  <div className="display_flex_row tableHeading">
    <div style={{ width: "2%" }}></div>
    <div style={{ width: "5%" }}>Requisition</div>
    <div style={{ width: "20%" }}>Start & End Date</div>
    <div style={{ width: "15%" }}>Start & End Time</div>
    <div style={{ width: "10%" }}>Req. Qty (MW)</div>
    <div style={{ width: "10%" }}>Min. Qty (MW)</div>
    <div style={{ width: "20%" }}>
      {role === "consumer" ? "Lowest Bid" : "Self Bid"}
    </div>
    <div style={{ width: "15%" }}>
      {role === "consumer" ? "Bucket Filled" : "Status"}
    </div>
  </div>
);

const AccordionRow = ({
  ele,
  index,
  expanded,
  handleAccordionChange,
  role,
  type,
  status,
}) => {
  const location = useLocation();
  const pathname = location?.pathname === "/bidding";
  const totalReq = ele?.requiredQty;
  console.debug(status);
  let bidList =
    status?.includes("tender_closing_soon") || status?.includes("closed")
      ? ele?.bids?.filter(
          (ele) =>
            ele?.winnerBidStatus === "PENDING" ||
            ele?.winnerBidStatus === "ACCEPTED" ||
            ele?.winnerBidStatus === "AWARDED"
        )
      : ele?.bids;

  const bucketBid = bidList?.reduce(
    (acc, curr) => acc + Number(curr?.selectedQuantity || curr?.bidQuantityMw),
    0
  );

  const [placeBid, setPlaceBid] = useState(false);
  const data = useSelector((state) => state?.auctionSlice?.tenderSpecefic);

  const handleUpdate = () => {
    window.location.reload();
  };

  const handlePlaceBid = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setPlaceBid(true);
  };

  return (
    <>
      {placeBid && (
        <PlaceBid
          open={placeBid}
          handleClose={() => setPlaceBid(false)}
          tenderData={data}
          requisitionData={ele}
          bidStage={type}
          handleUpdate={handleUpdate}
          status={status}
          // viewBids={viewBids}
        />
      )}
      <Accordion
        key={index}
        expanded={expanded.includes(index)}
        onChange={() =>
          !(type === "CB" && role === "generator") &&
          handleAccordionChange(index)
        }
        className={
          expanded.includes(index) && !(type === "CB" && role === "generator")
            ? Styles.activeAccordion
            : Styles.InactiveAccordion
        }
      >
        <AccordionSummary>
          <div
            className={`display_flex_row tableDetails ${
              Styles.accordionSummary
            } ${
              expanded.includes(index) &&
              !(type === "CB" && role === "generator") &&
              Styles.activeOpenAccordion
            }`}
          >
            <div style={{ width: "2%" }}>
              {!(type === "CB" && role === "generator") && (
                <ExpandMoreIcon
                  className={`${Styles.expandIconLeft} ${
                    expanded.includes(index) ? Styles.iconExpanded : ""
                  }`}
                />
              )}
            </div>
            <div style={{ width: "5%" }}>{index + 1}</div>
            <div style={{ width: "20%" }}>{`${formatDateType(
              ele?.dateStartAt
            )} to ${formatDateType(ele?.dateEndAt)}`}</div>
            <div style={{ width: "15%" }}>{`${ele?.slotStartAt} to ${
              ele?.slotEndAt === "23:59" ? "24:00" : ele?.slotEndAt
            }`}</div>
            <div style={{ width: "10%" }}>{ele?.requiredQty}</div>
            <div style={{ width: "10%" }}>{ele?.minimumQty}</div>
            <div style={{ width: "20%" }}>
              {role === "consumer" && ele?.lowestBidQty ? (
                <>
                  {ele?.lowestBidQty} (MW) / {ele?.lowestBidPrice} (₹/kWh)
                </>
              ) : role === "generator" && ele?.selfBid?.bidQuantityMw ? (
                <>
                  {ele?.selfBid?.bidQuantityMw} (MW) / {ele?.selfBid?.bidPrice}{" "}
                  (₹/kWh)
                </>
              ) : (
                <>-</>
              )}
            </div>
            <div style={{ width: "15%" }}>
              {role === "consumer" ? (
                <div className="display_flex_row_center">
                  <CircularProgress
                    value={bucketBid || 0}
                    required={ele?.requiredQty}
                  />
                </div>
              ) : (
                <>
                  {status?.includes("tender_closing_soon") ||
                  status?.includes("ra_upcoming") ||
                  (status?.includes("ra_ongoing") && pathname) ? (
                    <div
                      className={
                        ele?.selfBid?.bidStatus === "SHORTLISTED" ||
                        ele?.selfBid?.bidStatus === "SHORTLISTED_RA"
                          ? "accepted"
                          : "rejected"
                      }
                    >
                      {console.debug(ele?.selfBid)}
                      {ele?.selfBid?.bidStatus === "SHORTLISTED" ||
                      ele?.selfBid?.bidStatus === "SHORTLISTED_RA"
                        ? "Accepted"
                        : ele?.selfBid?.bidStatus === "REJECTED" ||
                          (ele?.selfBid?.bidStatus === "PLACED" &&
                            ele?.selfBid?.bidStage === "CB") ||
                          !ele?.selfBid
                        ? "Rejected"
                        : "-"}
                    </div>
                  ) : (
                    <>
                      {status?.includes("cb_ongoing") ||
                      status?.includes("ra_ongoing") ? (
                        <>
                          {(ele?.selfBid && status?.includes("ra_ongoing")) ||
                          (status.includes("cb_ongoing") &&
                            !status.includes("ra_ongoing")) ? (
                            <div
                              className={`activeButton_type_2 ${Styles.bidButtons}`}
                              onClick={(e) => handlePlaceBid(e)}
                            >
                              {ele?.selfBid ? "Edit Bid" : "Place Bid"}
                            </div>
                          ) : (
                            <div className="rejected">Rejected</div>
                          )}
                        </>
                      ) : (
                        <>-</>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </AccordionSummary>

        <AccordionDetails>
          <div className={Styles.accordionDetails}>
            {role === "generator" && ele?.selfBid ? (
              <AccordionDetailsContent
                bids={
                  status?.includes("tender_closing_soon") &&
                  role === "generator"
                    ? [ele?.selfBid]
                    : ele?.bids
                }
                type={type}
                status={status}
                selfBidId={ele?.selfBid?.id}
              />
            ) : role === "consumer" ? (
              <AccordionDetailsContent
                bids={
                  status?.includes("tender_closing_soon") &&
                  role === "generator"
                    ? [ele?.selfBid]
                    : ele?.bids
                }
                type={type}
                status={status}
                selfBidId={ele?.selfBid?.id}
              />
            ) : (
              <></>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

const AccordionDetailsContent = ({ bids, type, status, selfBidId }) => {
  console.debug("bids", bids);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  )?.toLowerCase();
  const [bidList, setBidList] = useState(bids);

  const [reqEditId, setReqEditId] = useState("");
  const [reqQuantity, setReqQuantity] = useState("");

  const handleChangeBidRequest = async (actualQty) => {
    if (actualQty === reqQuantity || reqQuantity === 0 || reqQuantity === "")
      return ErrorMessage("Selected and required quantity is same");
    let payload = {
      bidIdToQuantityMap: {
        [reqEditId]: Number(reqQuantity), //bidId to amount map
      },
    };
    let res = await updateQuantityRequest(payload);
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      window.location.reload();
    }
  };

  const handleAcceptRequest = async (id, val) => {
    let payload = {
      bidIdToStatusMap: {
        [id]: val, //bidId to amount map
      },
    };
    let res = await approveQuantityRequest(payload);
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      window.location.reload();
    }
  };

  const handleBidActivity = async (id, value) => {
    let payload = {
      bidIdToStatusMap: {
        [id]: value,
      },
    };
    let res = await updateWinnerBidStatus(payload);
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      const updatedBids = bidList?.map((bid) =>
        bid.id === id ? { ...bid, winnerBidStatus: value } : bid
      );
      setBidList(updatedBids);
    }
  };

  const handleReqQuantity = (value, selected) => {
    if (Number(value) >= Number(selected)) {
      return ErrorMessage("Value should be less then Selected Quantity");
    } else {
      setReqQuantity(value);
    }
  };

  if (
    ((type === "CB" || type === "AUCTION") &&
      role === "consumer" &&
      !status?.includes("tender_closing_soon")) ||
    (type === "AUCTION" && !status?.includes("tender_closing_soon"))
  ) {
    return (
      <div className={Styles.tableMainContainer}>
        <div className="display_flex_row tableHeading_type2">
          <div style={{ width: "30%" }}>Bid Quantity (MW)</div>
          <div style={{ width: "30%" }}>Bid Price (₹/kWh)</div>
          {/* <div style={{ width: "30%" }}>Last Activity At</div> */}
        </div>
        <div className={`scroll_bar_y ${Styles.maxBidViewContainer}`}>
          {!bidList && (
            <div className={`display_flex_row_center ${Styles.noBidElement}`}>
              No Bids Yet
            </div>
          )}
          {bidList?.map((bid, i) => (
            <div
              key={i}
              className={`display_flex_row tableDetails  ${
                Styles.viewElemCont
              } ${bid?.id === selfBidId && Styles.selfBidElem}`}
            >
              <div className={Styles.bidStatusBox}>
                {bid?.id === selfBidId && (
                  <div className={Styles.selfText}>Self</div>
                )}
              </div>
              <div style={{ width: "30%" }}>{bid?.bidQuantityMw}</div>
              <div style={{ width: "30%" }}>{bid?.bidPrice}</div>
              {/* <div style={{ width: "30%" }}>
                {formatDateTimeView(bid?.updatedAt)}
              </div> */}
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (status?.includes("tender_closing_soon") && type === "AUCTION") {
    return (
      <div className={Styles.tableMainContainer}>
        <div className="display_flex_row tableHeading_type2">
          {role === "consumer" ? (
            <>
              <div style={{ width: "15%" }}>Bid Quantity (MW)</div>
              <div style={{ width: "15%" }}>Selected Quantity (MW)</div>
              <div style={{ width: "15%" }}>Bid Price (₹/kWh)</div>
              <div style={{ width: "15%" }}>Last Activity At</div>
              <div style={{ width: "15%" }}>Status</div>
              <div style={{ width: "15%" }}>
                {/* <div
                  className={`${
                    reqEdit ? "activeButton_type_3" : "activeButton_type_2"
                  } ${Styles.editElement}`}
                  onClick={() => setReqEdit(!reqEdit)}
                >
                  {reqEdit ? (
                    <Close style={{ fontSize: "16px" }} />
                  ) : (
                    <EditIcon style={{ fontSize: "16px" }} />
                  )}
                </div> */}
                Alter
              </div>
            </>
          ) : role === "generator" ? (
            <>
              <div style={{ width: "15%" }}>Bid Quantity (MW)</div>
              <div style={{ width: "15%" }}>Selected Quantity (MW)</div>
              <div style={{ width: "15%" }}>Proposed Quantity (MW)</div>
              <div style={{ width: "15%" }}>Bid Price (₹/kWh)</div>
              <div style={{ width: "15%" }}>Last Activity At</div>
              <div style={{ width: "15%" }}>Status</div>
            </>
          ) : (
            <></>
          )}
        </div>
        {/* Example rows (replace with dynamic mapping if available) */}
        <div className={`scroll_bar_y ${Styles.maxBidViewContainer}`}>
          <>
            {role === "consumer" ? (
              <>
                {!bids && (
                  <div
                    className={`display_flex_row_center ${Styles.noBidElement}`}
                  >
                    No Bids Yet
                  </div>
                )}
                {bidList?.map((bid, i) => (
                  <div key={i} className="display_flex_row tableDetails">
                    <div style={{ width: "15%" }}>{bid?.bidQuantityMw}</div>
                    {reqEditId === bid?.id ? (
                      <div
                        style={{ width: "15%" }}
                        className={Styles.alter_input_cont}
                      >
                        <input
                          type="text"
                          value={reqQuantity}
                          onChange={(e) =>
                            handleReqQuantity(
                              e.target.value,
                              bid?.selectedQuantity
                            )
                          }
                        />
                      </div>
                    ) : (
                      <div style={{ width: "15%" }}>
                        {bid?.selectedQuantity || "-"}
                      </div>
                    )}
                    <div style={{ width: "15%" }}>{bid?.bidPrice}</div>
                    <div style={{ width: "15%" }}>
                      {bid?.updatedAt && formatDateTimeView(bid?.updatedAt)}
                    </div>
                    <div style={{ width: "15%" }}>
                      {bid?.selfBid?.winnerBidStatus === "ACCEPTED" ||
                      bid?.winnerBidStatus === "ACCEPTED" ||
                      bid?.selfBid?.winnerBidStatus === "AWARDED" ||
                      bid?.winnerBidStatus === "AWARDED" ? (
                        <div className="accepted">Selected</div>
                      ) : bid?.selfBid?.winnerBidStatus === "WITHDRAWN" ||
                        bid?.winnerBidStatus === "WITHDRAWN" ? (
                        <div className="rejected">Withdrawn</div>
                      ) : bid?.selfBid?.winnerBidStatus === "PENDING" ||
                        bid?.winnerBidStatus === "PENDING" ? (
                        <div className="pending">Pending</div>
                      ) : bid?.selfBid?.winnerBidStatus === "ABSCOND" ||
                        bid?.winnerBidStatus === "ABSCOND" ? (
                        <div className="rejected">Absconded</div>
                      ) : (
                        <div className="rejected">Rejected</div>
                      )}
                    </div>
                    <div
                      style={{ width: "15%" }}
                      className={`display_flex_row_gap_8 ${Styles.alterContainer}`}
                    >
                      {/* {reqEdit ? (
                        <div
                          className={`activeButton_type_2 ${Styles.sendReqButton}`}
                          onClick={() => handleChangeBidRequest()}
                        >
                          <DoneIcon style={{ fontSize: "14px" }} />
                        </div>
                      ) : (
                        <div
                          className={`activeButton_type_3 ${Styles.removeElement}`}
                        >
                          <HighlightOffIcon style={{ fontSize: "12px" }} />
                        </div>
                      )} */}
                      {reqEditId === bid?.id ? (
                        <>
                          <div
                            className={Styles.sendReqButton}
                            onClick={() =>
                              handleChangeBidRequest(bid?.bidQuantityMw)
                            }
                          >
                            <DoneIcon
                              style={{ fontSize: "16px", color: "#f1935c" }}
                            />
                          </div>
                          <div
                            className={Styles.removeElement}
                            onClick={() => setReqEditId("")}
                          >
                            <Close style={{ fontSize: "16px" }} />
                          </div>
                        </>
                      ) : (
                        <>
                          {bid?.selfBid?.winnerBidStatus === "ACCEPTED" ||
                          bid?.winnerBidStatus === "ACCEPTED" ||
                          bid?.selfBid?.winnerBidStatus === "ABSCOND" ||
                          bid?.winnerBidStatus === "ABSCOND" ? (
                            // ||
                            // bid?.selfBid?.winnerBidStatus !== "WITHDRAWN" ||
                            // bid?.winnerBidStatus !== "WITHDRAWN"
                            <>
                              <div
                                className={Styles.removeElement}
                                onClick={() => {
                                  setReqEditId(bid?.id);
                                  setReqQuantity(bid?.selectedQuantity);
                                }}
                              >
                                <EditIcon
                                  style={{ fontSize: "16px", color: "#6f6d7c" }}
                                />
                              </div>
                              <div>
                                <AntSwitch
                                  checked={
                                    (bid?.winnerBidStatus === "ACCEPTED" ||
                                      bid?.winnerBidStatus === "PENDING") &&
                                    true
                                  }
                                  onChange={() =>
                                    handleBidActivity(
                                      bid?.id,
                                      bid?.winnerBidStatus === "ACCEPTED"
                                        ? "ABSCOND"
                                        : "ACCEPTED"
                                    )
                                  }
                                />
                              </div>
                            </>
                          ) : (
                            <>-</>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </>
            ) : role === "generator" ? (
              <>
                {!bidList && (
                  <div
                    className={`display_flex_row_center ${Styles.noBidElement}`}
                  >
                    No Bids Yet
                  </div>
                )}
                {/* {
                  status === "tender_closing_soon" ? []
                } */}
                {bidList?.map((bid, i) => (
                  <div key={i} className="display_flex_row tableDetails">
                    <div style={{ width: "15%" }}>
                      {bid?.bidQuantityMw || "-"}
                    </div>
                    <div style={{ width: "15%" }}>
                      {bid?.selectedQuantity || "-"}
                    </div>
                    <div style={{ width: "15%" }}>
                      {bid?.selectedQuantity || "-"}
                    </div>
                    <div style={{ width: "15%" }}>{bid?.bidPrice}</div>
                    <div style={{ width: "15%" }}>
                      {bid?.updatedAt && formatDateTimeView(bid?.updatedAt)}
                    </div>
                    <div
                      style={{ width: "15%" }}
                      className={`display_flex_row_gap_8 ${Styles.bidAlterButtonCont}`}
                    >
                      {console.debug("bid", bid)}
                      {bid?.winnerBidStatus === "WITHDRAWN" ? (
                        <div>WITHDRAWN</div>
                      ) : bid?.winnerBidStatus === "ACCEPTED" ||
                        bid?.winnerBidStatus === "AWARDED" ? (
                        <div>Selected</div>
                      ) : bid?.winnerBidStatus === "PENDING" ? (
                        <>
                          <div
                            className={Styles.rejectBtn}
                            onClick={() =>
                              handleAcceptRequest(bid?.id, "WITHDRAWN")
                            }
                          >
                            Reject
                          </div>
                          <div
                            className={Styles.acceptBtn}
                            onClick={() =>
                              handleAcceptRequest(bid?.id, "ACCEPTED")
                            }
                          >
                            Accept
                          </div>
                        </>
                      ) : (
                        <div>
                          {bid?.bidStatus === "PLACED" &&
                          status?.includes("tender_closing_soon")
                            ? "Waiting"
                            : ""}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <></>
            )}
          </>
        </div>
      </div>
    );
  }
};

// ----------------- Main Component -----------------
const BiddingScreen = ({ type }) => {
  const location = useLocation();
  const tenderData = useSelector(
    (state) => state?.auctionSlice?.tenderSpecefic
  );
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  )?.toLowerCase();

  const [expanded, setExpanded] = useState([0]);
  const [reqList, setReqList] = useState(null);
  console.debug(reqList, tenderData, "tenderData");

  const [selectedBid, setSelectedBid] = useState([]);

  const [energyRateSortDir, setEnergyRateSortDir] = React.useState("");
  const [quantitySortDir, setQuantitySortDir] = React.useState("");
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [listingCount, setListingCount] = useState(0);
  const [filterState, setFilterState] = useState({
    quantity: [0, 10000],
    energyRate: [0, 200],
    creditRating: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });

  let tenderTimeDate = {
    tenderStartDateTime: tenderData?.tenderStartDateTime,
    tenderCloseDateTime: tenderData?.tenderCloseDateTime,
    bidStartDateTime: tenderData?.bidStartDateTime,
    bidCloseDateTime: tenderData?.bidCloseDateTime,
    auctionStartDateTime: tenderData?.auctionStartDateTime,
    auctionCloseDateTime: tenderData?.auctionCloseDateTime,
  };
  let status = tenderData && getTenderState(tenderTimeDate);
  console.debug("Status:", status);

  useEffect(() => {
    if (tenderData?.id) fetchReqDetails();
  }, [tenderData]);

  const fetchReqDetails = async () => {
    if (type === "RA_ACTIVE" || type === "RA_ONGOING") return;
    if (role === "consumer") {
      const res = await getequisitionsList(tenderData?.id, type);
      if (res?.data?.code === 200) {
        setReqList(res?.data?.data);
        let reqList = res?.data?.data;
        let allBids = reqList?.flatMap((req) => req.bids || []);

        // Filter out requisitions where at least one bid has bidStatus "SHORTLISTED_RA"
        let finalList = allBids
          ?.filter((ele) => ele?.winnerBidStatus === "ACCEPTED")
          ?.map((bid) => bid?.id);
        console.log("All Bids:", finalList);
        setSelectedBid(finalList);
      }
    } else if (role === "generator") {
      const res = await getequisitionsBidders(tenderData?.id, type);
      if (res?.data?.code === 200) setReqList(res?.data?.data);
    }
  };

  const handleAccordionChange = (index) => {
    setExpanded((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const navList = [
    // {
    //   name: "Bidding",
    //   link: "/bidding",
    //   current: location?.pathname === "/bidding",
    //   active: true,
    // },
    // {
    //   name: "Reverse Auction",
    //   link: "/live_auction",
    //   current: location?.pathname === "/live_auction",
    //   active: status?.includes("ra_ongoing"),
    // },
    // {
    //   name: "Ongoing Contract",
    //   link: "/tender_active",
    //   current: location?.pathname === "/tender_active",
    //   active:
    //     status?.includes("tender_closing_soon") &&
    //     tenderData?.tenderStatus === "TERMS",
    // },
    // {
    //   name: "Ongoing Contract",
    //   link: "/tender_ongoing",
    //   current: location?.pathname === "/tender_ongoing",
    //   active: true,
    // },
  ];

  return (
    <>
      {!tenderData ? (
        <Loader />
      ) : (
        <div className={Styles.biddingScreenContainer}>
          <AuctionHeader
            heading={
              <>
                <div
                  style={{
                    height: "45px",
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <div>
                    <span>Tender Details </span>
                    <span style={{ fontSize: "10px" }}>
                      ({`${tenderData?.tenderNumber}`})
                    </span>
                  </div>
                  <div
                    style={{
                      color: "#f1935c",
                      // fontSize: "14px",
                      paddingBottom: "2px",
                    }}
                  >
                    Selected Bids
                  </div>
                </div>
              </>
            }
            navigation={navList}
          />

          <div className={Styles.biddingMainScreen}>
            <div className={Styles.tenderDetailsSection}>
              <TenderDetails
                tenderData={tenderData}
                type={type}
                status={status}
              />
              {type !== "TERMS" && (
                <TenderActions
                  tenderData={tenderData}
                  status={status}
                  selectedBidIds={selectedBid}
                />
              )}
            </div>

            <div className={`scroll_bar_y ${Styles.ongoingTenderComponent}`}>
              {type === "RA_ONGOING" || type === "RA_ACTIVE" ? (
                <>
                  <AvailableListing
                    isReverseAuction={true}
                    searchCapId={
                      role === "consumer"
                        ? tenderData?.capacityId
                        : tenderData?.generatorCapacityId
                    }
                    showBackbtn={true}
                    filterState={filterState}
                    energyRateSortDir={energyRateSortDir}
                    quantitySortDir={quantitySortDir}
                    setEnergyRateSortDir={setEnergyRateSortDir}
                    setQuantitySortDir={setQuantitySortDir}
                    activeFilter={activeFilter}
                    setListingCount={setListingCount}
                  />
                </>
              ) : (
                <div className={Styles.biddingTableContainer}>
                  <TableHeader role={role} />

                  <div className={`scroll_bar_y ${Styles.accodianCont}`}>
                    {reqList?.map((ele, index) => (
                      <AccordionRow
                        key={index}
                        ele={ele}
                        index={index}
                        expanded={expanded}
                        handleAccordionChange={handleAccordionChange}
                        role={role}
                        type={type}
                        status={status}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* {type === "RA_ONGOING" ? (
              <div className={`scroll_bar_y ${Styles.ongoingTenderComponent}`}>
                <OngoingConnections
                  capacityId={
                    role === "consumer"
                      ? tenderData?.capacityId
                      : tenderData?.generatorCapacityId
                  }
                  type={type}
                />
              </div>
            ) : type === "RA_ACTIVE" ? (
              <div className={`scroll_bar_y ${Styles.ongoingTenderComponent}`}>
                <OngoingConnections
                  capacityId={
                    role === "consumer"
                      ? tenderData?.capacityId
                      : tenderData?.generatorCapacityId
                  }
                  type={type}
                />
              </div>
            ) : (
              <div className={Styles.biddingTableContainer}>
                <TableHeader role={role} />

                <div className={`scroll_bar_y ${Styles.accodianCont}`}>
                  {reqList?.map((ele, index) => (
                    <AccordionRow
                      key={index}
                      ele={ele}
                      index={index}
                      expanded={expanded}
                      handleAccordionChange={handleAccordionChange}
                      role={role}
                      type={type}
                      status={status}
                    />
                  ))}
                </div>
              </div>
            )} */}
          </div>
        </div>
      )}
    </>
  );
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "var(--primary-color-text)",
        ...theme.applyStyles("dark", {
          backgroundColor: "var(--primary-color-text)",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(149, 148, 148, 0.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

export default BiddingScreen;
